import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/homepage-business/heroBackground-light.png?url';

export default {
  lqip: `data:image/png;base64,UklGRpAAAABXRUJQVlA4WAoAAAAQAAAAHwAAEwAAQUxQSAoAAAABB9D9iAhERP8DVlA4IGAAAACQBACdASogABQAPm0yk0ckIyGhKAqogA2JQBdgBp38CindUdJqxABqJc5XVFAA/v6Tjy7sTd6xryWc0grY0ohYoeM3bYzdubjz0RrXSaA0bJpZZ+1evAJrAXd/4P8gAAA=`,
  src,
  width: 4320,
  height: 2742,
};
			